import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PropsLogin } from "../types/typeProps";
import { fetchData } from "./config";
import { ErrorType } from "./errorType";
import packageInfo from "../../package.json";
// const dev = process.env.REACT_APP_DEVELOPMENT
interface UserExtra {
  phone: string;
  avatar: string;
  linkedin: string;
  facebook: string;
  instagram: string;
  twitter: string;
  id_company: number;

  id_occupation: number;
  public_user: number;
  gender: string;
  title: string;
  address: string;
  address_2: string;
  employee_ext: string;
  employee_suit: string;
  employee_city: string;
  employee_state: string;
  employee_zip_code: string;
  email_alternative: string;
  edit_status: number;
}
interface Employee {
  division_brand: string;
  full_name: string;
  company: string;
  job: string;
  title: string;
  city: string;
  state: string;
  zip_code: string;
  work_phone: string;
  work_extension: string;
  location_address1: string;
  location_address2: string;
}
interface UserState {
  id: number;
  id_company: number;
  id_occupation: number;
  public_user: number;
  id_encrypted: string;
  id_employee: string;
  name: string;
  full_name: string;
  email: string;
  gender: string;
  phone: string;
  address: string;
  address_2: string;
  employ_phone: string;
  customer_phone: string;
  employ_address: string;
  employ_title: string;
  title: string;
  employee_code: string;
  company: string;
  avatar: string;
  extra: UserExtra;
  employee: Employee;
  token: string;
  status: string;
  isLogin: boolean;
  errorMessage: string;
  errorType: ErrorType | null;
  timelogin: number;
  skills: string[];
}

const initialState: UserState = {
  id: 0,
  id_company: 0,
  id_occupation: 0,
  public_user: 0,
  id_encrypted: "",
  id_employee: "",
  name: "",
  full_name: "",
  email: "",
  gender: "",
  phone: "",
  address: "",
  address_2: "",
  employ_phone: "",
  customer_phone: "",
  employ_address: "",
  employ_title: "",
  title: "",
  employee_code: "",
  company: "",
  avatar: "",
  extra: {
    phone: "",
    avatar: "",
    linkedin: "",
    facebook: "",
    instagram: "",
    twitter: "",
    id_company: 0,
    id_occupation: 0,
    public_user: 0,
    gender: "",
    title: "",
    address: "",
    address_2: "",
    employee_ext: "",
    employee_suit: "",
    employee_city: "",
    employee_state: "",
    employee_zip_code: "",
    email_alternative: "",
    edit_status: 0,
  },
  employee: {
    division_brand: "",
    full_name: "",
    company: "",
    job: "",
    title: "",
    city: "",
    state: "",
    zip_code: "",
    work_phone: "",
    work_extension: "",
    location_address1: "",
    location_address2: "",
  },
  isLogin: false,
  token: "",
  status: "",
  errorMessage: "",
  errorType: null,
  timelogin: 0,
  skills: [],
};

/* thunk login step one */
export const Login = createAsyncThunk<any, PropsLogin>(
  "user/login",
  async (datos) => {
    const response = await fetchData().post("/api/guardian/users/login", datos);
    const dataResponse = response.data;
    const skills = Object.values(dataResponse.data.skills);
    const saveState = {
      id: dataResponse.data.id,
      id_company: dataResponse.data.extra.id_company,
      id_occupation: dataResponse.data.extra.id_occupation,
      public_user: dataResponse.data.extra.public_user,
      id_encrypted: dataResponse.data.id_encrypted,
      id_employee: dataResponse.data.employee.id_encrypted,
      token: dataResponse.access_token,
      name: dataResponse.data.name,
      full_name: dataResponse.data.employee.full_name,
      email: dataResponse.data.email,
      gender: dataResponse.data.extra.gender,
      phone: dataResponse.data.extra.phone,
      address: dataResponse.data.extra.address,
      address_2: dataResponse.data.extra.address_2,
      employ_phone: dataResponse.data.employee.work_phone,
      customer_phone: dataResponse.data.employee.customer_phone,
      employ_address: `${dataResponse.data.employee.location_address1},${` `}${dataResponse.data.employee.city
        },${` `}${dataResponse.data.employee.state},${` `}${dataResponse.data.employee.zip_code
        }`,
      employ_title: dataResponse.data.employee.title,
      title: dataResponse.data.extra.title,
      avatar: dataResponse.data.extra.avatar
        ? dataResponse.data.extra.avatar
        : "default",
      employee_code: dataResponse.data.employee.employee_code,
      company: dataResponse.data.employee.division_brand,
      extra: dataResponse.data.extra,
      employee: dataResponse.data.employee,
      skills,
    };
    return saveState;
  },
);

/* thunk login step two */
interface ReponseVerify {
  status: boolean;
  data?: boolean;
  error?: string;
}

interface PropsVerify {
  auth_token: string;
  token_type: number;
}

export const VerifyCode = createAsyncThunk<
  ReponseVerify,
  PropsVerify,
  { rejectValue: ReponseVerify }
>("user/verify", async (datos) => {
  const reseponse = fetchData().post(`/api/guardian/users/token/check`, datos);
  return (await reseponse).data;
});

interface PropsUpdate {
  id: number;
  id_company: number;
  id_occupation: number;
  public_user: number;
  name: string;
  email: string;
  phone: string;
  address: string;
  title: string;
  employee_ext: string;
  employee_suit: string;
  employee_state: string;
  employee_city: string;
  email_alternative: string;
  employee_zip_code: string;
  file_avatar?: File | string;
}

export const updateProfile = createAsyncThunk<any, PropsUpdate>(
  "user/update",
  async ({
    id,
    id_company,
    public_user,
    id_occupation,
    name,
    email,
    phone,
    address,
    title,
    employee_ext,
    employee_suit,
    employee_city,
    employee_state,
    email_alternative,
    employee_zip_code,
    file_avatar,
  }: PropsUpdate) => {
    if (file_avatar !== undefined) {
      const formData = new FormData();
      formData.append("file_avatar", file_avatar);
      formData.append("phone", phone);
      formData.append("address", address);
      formData.append("title", title);
      formData.append("id_user", "" + id);
      formData.append("id_company", "" + id_company);
      formData.append("id_occupation", "" + id_occupation);
      formData.append("public_user", "" + public_user);
      formData.append("employee_ext", "" + employee_ext);
      formData.append("employee_suit", "" + employee_suit);
      formData.append("employee_city", "" + employee_city);
      formData.append("employee_state", "" + employee_state);
      formData.append("employee_zip_code", "" + employee_zip_code);
      formData.append("email_alternative", "" + email_alternative);
      const response = await fetchData().put(
        `/api/guardian/profile/users?versionjs=${packageInfo.version}`,
        { name, email },
      );
      /* const response_two = await fetchData().put(`/api/guardian/profile/extras?versionjs=${packageInfo.version}`, { avatar, gender, phone, address, title, id_user: id, id_company, id_occupation }) */
      const response_two = await fetchData().post(
        `/api/guardian/profile/extras?versionjs=${packageInfo.version}`,
        formData,
      );
      const dataResponse = (await response).data;
      const dataResponsetwo = (await response_two).data;
      const updateData = {
        name: dataResponse.data.name,
        email: dataResponse.data.email,
        extra: dataResponsetwo.data,
      };
      return updateData;
    } else {
      const formData = new FormData();
      formData.append("phone", phone);
      formData.append("address", address);
      formData.append("title", title);
      formData.append("id_user", "" + id);
      formData.append("id_company", "" + id_company);
      formData.append("id_occupation", "" + id_occupation);
      formData.append("public_user", "" + public_user);
      formData.append("employee_ext", "" + employee_ext);
      formData.append("employee_suit", "" + employee_suit);
      formData.append("employee_city", "" + employee_city);
      formData.append("employee_state", "" + employee_state);
      formData.append("employee_zip_code", "" + employee_zip_code);
      formData.append("email_alternative", "" + email_alternative);
      const response = await fetchData().put(
        `/api/guardian/profile/users?versionjs=${packageInfo.version}`,
        { name, email },
      );
      const response_two = await fetchData().post(
        `/api/guardian/profile/extras?versionjs=${packageInfo.version}`,
        formData,
      );
      const dataResponse = (await response).data;
      const dataResponsetwo = (await response_two).data;
      const updateData = {
        name: dataResponse.data.name,
        email: dataResponse.data.email,
        extra: dataResponsetwo.data,
      };
      return updateData;
    }
  },
);

export const refreshtoken = createAsyncThunk<any>(
  "user/refreshtoken",
  async () => {
    const response = await fetchData().post(
      `/api/guardian/users/refresh?versionjs=${packageInfo.version}`,
    );
    const dataResponse = (await response).data;
    return dataResponse;
  },
);

interface Propspass {
  password_old: string;
  password_new: string;
}

export const updatePassword = createAsyncThunk<any, Propspass>(
  "user/updatePassword",
  async ({ password_old, password_new }) => {
    const response = await fetchData().put(
      `/api/guardian/profile/users?versionjs=${packageInfo.version}`,
      { password_old, password_new },
    );
    return response.data;
  },
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logOut: (state) => {
      const logautState = {
        ...initialState,
        email: state.email,
      };
      return logautState;
    },
    cancelTwostep: (state) => {
      return initialState;
    },
    resetStatus: (state) => {
      state.status = "";
    },
    editToken: (state) => {
      state.token = state.token + "a";
    },
    sesisonExpired: (state) => {
      const sesionExpiredStatus = {
        ...initialState,
        email: state.email,
        errorMessage: "Your session has expired",
        errorType: ErrorType.ERROR_SERVER,
        status: "refreshtoken_expired_rejected",
      };
      return sesionExpiredStatus;
    },
  },
  extraReducers: (builder) => {
    /* Login step one */
    builder.addCase(Login.pending, (state) => {
      state.status = "Login_loading";
    });
    builder.addCase(Login.fulfilled, (state, { payload }) => {
      state.timelogin = Date.now();
      state.id = payload.id;
      state.id_company = payload.id_company;
      state.id_occupation = payload.id_occupation;
      state.public_user = payload.public_user;
      /* state.id_encrypted = payload.id_encrypted */
      state.id_employee = payload.id_employee;
      state.name = payload.name;
      state.full_name = payload.full_name;
      state.email = payload.email;
      state.gender = payload.gender;
      state.phone = payload.phone;
      state.address = payload.address;
      state.address_2 = payload.address_2;
      state.employ_phone = payload.employ_phone;
      state.customer_phone = payload.customer_phone;
      state.employ_address = payload.employ_address;
      state.employ_title = payload.employ_title;
      state.title = payload.title;
      state.employee_code = payload.employee_code;
      state.company = payload.company;
      state.avatar = payload.avatar;
      state.token = payload.token;
      state.extra = payload.extra;
      state.employee = payload.employee;
      state.skills = payload.skills;
      state.status = "Login_success";
      state.isLogin = true;
    });
    builder.addCase(Login.rejected, (state, { error }) => {
      if (error.name === "TypeError") {
        state.errorMessage =
          "You are not an employee of the system, please verify your login details or contact a system administrator.";
        state.errorType = ErrorType.ERROR_PERMISSION;
      } else {
        state.errorMessage = "Email or password is incorrect";
        state.errorType = ErrorType.ERROR_SERVER;
      }
      state.status = "Login_rejected";
    });
    /* login step two */

    builder.addCase(VerifyCode.pending, (state) => {
      state.status = "VerifyCode_loading";
    });
    builder.addCase(VerifyCode.fulfilled, (state, { payload }) => {
      state.status = "VerifyCode_success";
      state.isLogin = true;
    });
    builder.addCase(VerifyCode.rejected, (state, { error }) => {
      if (error.message === "Request failed with status code 422") {
        state.errorMessage = "The verification code is wrong";
        state.errorType = ErrorType.ERROR_PERMISSION;
      }
      if (error.message === "Request failed with status code 404") {
        state.errorMessage =
          "The server is not responding check your internet connection";
        state.errorType = ErrorType.ERROR_SERVER;
      }
      state.status = "VerifyCode_rejected";
    });

    /* update profile */

    builder.addCase(updateProfile.pending, (state) => {
      state.status = "updateProfile_loading";
    });
    builder.addCase(updateProfile.fulfilled, (state, { payload }) => {
      state.name = payload.name;
      state.email = payload.email;
      state.extra = payload.extra;
      state.status = "updateProfile_success";
    });
    builder.addCase(updateProfile.rejected, (state, { error }) => {
      if (
        error.message === "Request failed with status code 404" ||
        error.message === "Network Error"
      ) {
        state.errorMessage =
          "The server is not responding check your internet connection";
        state.errorType = ErrorType.ERROR_SERVER;
      }
      state.status = "updateProfile_rejected";
    });

    /* refrsh token */

    builder.addCase(refreshtoken.pending, (state) => {
      state.status = "refreshtoken_loading";
    });
    builder.addCase(refreshtoken.fulfilled, (state, { payload }) => {
      if (payload) {
        state.token = payload.access_token;
        state.timelogin = Date.now();
      }
      state.status = "refreshtoken_success";
    });
    builder.addCase(refreshtoken.rejected, (state, { error }) => {
      if (error.message === "Request failed with status code 508") {
        state.token = "";
        state.isLogin = false;
        state.errorMessage = "Your session has expired";
        state.errorType = ErrorType.ERROR_SERVER;
        state.status = "refreshtoken_expired_rejected";
      } else {
        state.status = "refreshtoken_rejected";
      }
    });

    /* Update password */

    builder.addCase(updatePassword.pending, (state) => {
      state.status = "updatePassword_loading";
    });
    builder.addCase(updatePassword.fulfilled, (state, { payload }) => {
      state.status = "updatePassword_success";
    });
    builder.addCase(updatePassword.rejected, (state, { error }) => {
      state.status = "updatePassword_rejected";
    });
  },
});

export const { logOut, cancelTwostep, resetStatus, editToken, sesisonExpired } =
  userSlice.actions;
export default userSlice.reducer;
